import { render, staticRenderFns } from "./create_closure.vue?vue&type=template&id=600ec3ba"
import script from "./create_closure.vue?vue&type=script&lang=js"
export * from "./create_closure.vue?vue&type=script&lang=js"
import style0 from "./create_closure.vue?vue&type=style&index=0&id=600ec3ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports